<!-- 公共底部 -->
<template>
    <div class="footer_wrap">

        <ul class="left">
            <li>北京盈科千信科技有限公司</li>
            <li>地址： 北京市海淀区中关村南大街48号</li>
        </ul>
        <ul class="right">
            <li>邮箱： product@increscence.net</li>
            <li style="font-family:">Copyright © {{year}}
                <img src="../assets/imgs/copy_n.png" alt=""> 京ICP备15054044号-1
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            year: new Date().getFullYear(), //当前年份
        };
    },
};
</script>
<style scoped lang='less'>
.footer_wrap {
    display: flex;
    min-width: 1180px;
    height: 80px;

    justify-content: center;
    align-items: center;
    background: #091a46;
    background: #013A57;
    // background: #4e6ef2;
}
.left {
    width: 250px;
    margin-right: 30px;
    color: #f4f4f4;
    img {
        width: 100%;
    }
    li + li {
        margin-top: 14px;
    }
}
.right {
    border-left: 2px solid #c5c2c2;
    padding-left: 30px;
    color: #f4f4f4;
    li + li {
        margin-top: 14px;
    }
    img {
        width: 20px;
        vertical-align: middle;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ComFooter.vue